import {
  liveConversationDetailSchema,
  liveListResponseSchema,
  liveSummarySchema,
  type LiveConversationDetail,
  type LiveListResponse,
  type LiveStatusFilter,
  type LiveSummary,
} from '@manaro/contracts'
import { apiRequest } from '@/shared/api/client.ts'

const base = (id: string) => `/support/live/conversations/${encodeURIComponent(id)}`

export const fetchLiveSummary = (signal?: AbortSignal): Promise<LiveSummary> =>
  apiRequest('/support/live/summary', { schema: liveSummarySchema, signal })

export const fetchLiveConversations = (filter: LiveStatusFilter, signal?: AbortSignal): Promise<LiveListResponse> =>
  apiRequest(`/support/live/conversations?status=${filter}`, { schema: liveListResponseSchema, signal })

export const fetchLiveConversation = (id: string, signal?: AbortSignal): Promise<LiveConversationDetail> =>
  apiRequest(base(id), { schema: liveConversationDetailSchema, signal })

export type LiveAction = 'takeover' | 'release' | 'close'

export const runLiveAction = (id: string, action: LiveAction): Promise<LiveConversationDetail> =>
  apiRequest(`${base(id)}/${action}`, { method: 'POST', body: {}, schema: liveConversationDetailSchema })

export const sendOperatorMessage = (id: string, text: string): Promise<LiveConversationDetail> =>
  apiRequest(`${base(id)}/messages`, { method: 'POST', body: { text }, schema: liveConversationDetailSchema })
